export default __webpack_public_path__ + "static/media/cross.582caa73.svg";